import { render, staticRenderFns } from "./UniversalUploader.vue?vue&type=template&id=dd2ebffa&"
import script from "./UniversalUploader.vue?vue&type=script&lang=js&"
export * from "./UniversalUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports